'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _lib = require('helpers/lib');

var _reactRedux = require('react-redux');

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _Marker = require('../Detail/Marker');

var _Marker2 = _interopRequireDefault(_Marker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoreInfoDetailMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop,
    location: state.user.coords
  };
}, (0, _extends3.default)({}, shopActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MoreInfoDetailMobile, _Component);

  function MoreInfoDetailMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MoreInfoDetailMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MoreInfoDetailMobile.__proto__ || (0, _getPrototypeOf2.default)(MoreInfoDetailMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      readMore: _this.props.shop && _this.props.shop.description.split(' ').length < 30 ? false : true,
      zoom: 14
    }, _this.renderDistance = function (userLocation, shopLocation) {
      var distance = Math.round((0, _lib.getDistanceFromLatLon)(userLocation.latitude, userLocation.longitude, shopLocation.lat, shopLocation.lng));
      if (distance > 1000) return Math.round(distance / 1000 * 10) / 10 + 'km';
      if (isNaN(distance)) return 'Không xác định';
      return distance + 'm';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MoreInfoDetailMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var shop = this.props.shop;

      document.getElementById('app-content').style.paddingBottom = 0;
      document.getElementById('app-content').style.backgroundColor = '#ffffff';
      this.props.getShopData(this.props.params.id);
      if (shop && shop.description && shop.description.trim().split(' ').length < 30 && this.refs.description) {
        this.refs.description.style.height = 'auto';
        this.refs.description.style.overflow = 'visible';
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.params.id !== nextProps.params.id) {
        this.props.getShopData(nextProps.params.id);
        document.getElementById('app-content').scrollTop = 0;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.scroll(0, 0);
      document.getElementById('app-content').style.paddingBottom = '57px';
      document.getElementById('app-content').style.backgroundColor = 'initial';
    }
  }, {
    key: 'readMoreHandler',
    value: function readMoreHandler() {
      var readMore = this.state.readMore;

      if (readMore) {
        this.refs.description.style.height = 'auto';
        this.refs.description.style.overflow = 'visible';
      } else {
        this.refs.description.style.height = '50px';
        this.refs.description.style.overflow = 'hidden';
      }
      this.setState({ readMore: !readMore });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./MoreInfoDetailMobile.scss');
      var _props = this.props,
          shop = _props.shop,
          location = _props.location;
      var readMore = this.state.readMore;

      var center = shop ? [shop.location.lat, shop.location.lng] : '';
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        shop && _react2.default.createElement(
          'div',
          { className: styles.wrapper },
          (!!shop.description || shop.openTime || shop.closeTime || shop.phone || shop.price_range) && _react2.default.createElement(
            'div',
            { className: styles.infoContainer },
            _react2.default.createElement(
              'div',
              { className: styles.infoTitle },
              'Th\xF4ng Tin'
            ),
            !!shop.description && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement(
                'div',
                { className: styles.descWrapper },
                _react2.default.createElement('i', { className: 'fa fa-file-text-o' }),
                _react2.default.createElement('div', {
                  className: styles.description,
                  dangerouslySetInnerHTML: { __html: shop.description },
                  ref: 'description'
                })
              ),
              readMore && _react2.default.createElement(
                'a',
                {
                  className: styles.readMore,
                  onClick: this.readMoreHandler.bind(this)
                },
                '\u0110\u1ECDc ti\u1EBFp'
              ),
              !readMore && shop.description.split(' ').length > 30 && _react2.default.createElement(
                'a',
                {
                  className: styles.readMore,
                  onClick: this.readMoreHandler.bind(this)
                },
                'R\xFAt g\u1ECDn'
              )
            ),
            shop.openTime && shop.closeTime && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
              'M\u1EDF c\u1EEDa: ' + (shop.openTime && shop.closeTime ? (0, _lib.number2Time)(shop.openTime) + ' ' + (0, _lib.number2Time)(shop.closeTime) : '' + shop.opening_time)
            ),
            shop.phone && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement('i', { className: 'fa fa-phone' }),
              shop.phone
            ),
            shop.price_range && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement('i', { className: 'fa fa-dollar' }),
              shop.price_range
            )
          ),
          (shop.address || shop.location) && _react2.default.createElement(
            'div',
            { className: styles.infoContainer },
            _react2.default.createElement(
              'div',
              { className: styles.infoTitle },
              'V\u1ECB tr\xED'
            ),
            shop.address && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement('i', { className: 'fa fa-map-marker' }),
              shop.address
            ),
            shop.location && _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement('i', { className: 'fa fa-compass' }),
              'C\xE1ch t\xF4i: ' + this.renderDistance(location, shop.location)
            ),
            shop.location && _react2.default.createElement(
              'div',
              { className: styles.map },
              _react2.default.createElement(
                _googleMapReact2.default,
                { center: center, zoom: this.state.zoom },
                _react2.default.createElement(_Marker2.default, { lat: shop.location.lat, lng: shop.location.lng })
              )
            )
          )
        )
      );
    }
  }]);
  return MoreInfoDetailMobile;
}(_react.Component), _class2.propTypes = {
  // data
  shop: _react.PropTypes.object,
  params: _react.PropTypes.object,
  location: _react.PropTypes.object,
  match: _react.PropTypes.object,
  // action
  getShopData: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = MoreInfoDetailMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/MoreInfoDetailMobile.js
// module id = 1590
// module chunks = 0